import { useEffect, useMemo, useState } from "react";
import { getInitials } from "../../../utils/helpers/getInitials";
import { resolveAssetUrl } from "../../../utils/helpers/storeSetting";

const AccountAvatar = ({ name = "Akun", image, size = "md", className = "" }) => {
  const source = useMemo(() => resolveAssetUrl(image, ""), [image]);
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [source]);

  return (
    <span className={`account-avatar account-avatar-${size} ${className}`.trim()} title={name}>
      {source && !failed ? (
        <img src={source} alt={name} loading="lazy" decoding="async" onError={() => setFailed(true)} />
      ) : (
        <span aria-hidden="true">{getInitials(name || "Akun") || "A"}</span>
      )}
    </span>
  );
};

export default AccountAvatar;
